<template>
    <div class="xinwem">
        <div class="xinwem1">
            <div class="anliLeft" style="width: 15%;color: #fff;font-size: 20px;">
                <h4 style="margin-top: 150px;">CLIENT</h4>
                <h4>CASE</h4>
                <h3 style="line-height: 60px;">新闻动态</h3>
                <p style="margin-top: 130px;"><span
                        style="padding:10px 15px;border: 1px solid #fff;font-size: 16px;">More></span></p>
            </div>
            <div class="anliRight" style="flex: 1;margin-left: 10px;margin-top: 70px;">
                <el-carousel height="500px">
                    <el-carousel-item v-for="item in num" :key="item">
                        
                        <div style="width: 100%;display: flex;justify-content: space-between;margin-top: 3%;flex-wrap: wrap;color: #fff;" >
                            <div style="width: 270px;border-bottom: 3px solid #0086d1;background: rgba(0, 0, 0, 0.3);overflow: hidden;"
                                class="tj1"  v-for="item1 in getContentList"  @click=" openNewAll(item1)">
                                <img :src="item1.img" alt="" style="width: 270px;height: 240px;">
                                        <h3 class="tj1A" style="color: #fff;">{{item1.title}}</h3>
                                        <p class="tj1B" style="color: #fff;"><span><i class="el-icon-time">

                                </i>{{item1.time1}}</span><span><i class="el-icon-s-check"></i>{{item1.num}}</span></p>
                                <p class="tj1C" style=""><span style="">查看详情</span></p>
                            </div>

                            <!-- <div style="width: 270px;border-bottom: 3px solid #0086d1;background: rgba(0, 0, 0, 0.3);"
                                class="tj1">
                                <img src="../../../assets/0817b3f3a5ac97876f40a358fa157136.png" alt=""
                                    style="width: 270px;height: 240px;">
                                <h3 class="tj1A" style="color: #fff;">一岛一世界</h3>
                                <p class="tj1B" style="color: #fff;"><span><i class="el-icon-time">

                                        </i>2021-11-04 19:39:49 </span><span><i class="el-icon-s-check"></i></span></p>
                                <p class="tj1C" style=""><span style="">查看详情</span></p>
                            </div>


                            <div style="width: 270px;border-bottom: 3px solid #0086d1;background: rgba(0, 0, 0, 0.3);"
                                class="tj1">
                                <img src="../../../assets/0817b3f3a5ac97876f40a358fa157136.png" alt=""
                                    style="width: 270px;height: 240px;">
                                <h3 class="tj1A" style="color: #fff;">一岛一世界</h3>
                                <p class="tj1B" style="color: #fff;"><span><i class="el-icon-time">

                                        </i>2021-11-04 19:39:49 </span><span><i class="el-icon-s-check"></i></span></p>
                                <p class="tj1C" style=""><span style="">查看详情</span></p>
                            </div> -->
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            getContentList:[],
            total: 0,
            currentPage: 1,
            pageSize: 3,
            num:''
        }
    },
    mounted() {
        this.$axios
            .get("/system/content/getContentList",  { params:{pageNum: this.currentPage, pageSize: this.pageSize, type: '10' }})
            .then(res => {
                if (res.code == 0) {
                    var array = res.data.rows
          for (let index = 0; index < array.length; index++) {
            array[index]['time1'] = array[index].time.slice(0, 10)
          }
                this.getContentList = array
                this.num =Math.ceil(this.getContentList.length/3) 
                console.log(this.num,'this.numthis.numthis.numthis.num',this.getContentList)
                } else {
                this.$message.closeAll();
                this.$message.error(res.msg);
                }
            });
    },
    methods: {
      openNewAll(row){
            sessionStorage.setItem("top", '5');
            this.$router.push({
            path: "/offerACoursedetails",
            query: row
        });
        },
    }
};
</script>

<style lang="less">
.xinwem {
    background-image: url("../../../assets/xinwen.jpg");
    background-size: cover;
    /* 背景图片覆盖整个元素 */
    background-repeat: no-repeat;
    /* 背景图片不重复 */
    background-position: center;
    /* 背景图片居中 */
    width: 100%;
    /* 元素宽度 */
    height: 1040px;
    padding: 60px 0 0;

    .xinwem1 {
        width: 1200px;
        margin: 0 auto;
        display: flex;
    }

    .tj1A {
        padding: 0 20px;
        color: #4c4c4c;
        font-family: 'montserratregular';
        font-size: 24px;
        margin-bottom: 10px;
    }

    .tj1B {
        padding: 0 20px;
        color: #4c4c4c;
        font-family: 'montserratregular';
        font-size: 14px;
    }

    .tj1C {
        padding: 0 20px;
        margin: 20px 0 50px 0;

        span {
            background: #0086d1;
            color: #fff;
            padding: 8px 20px;
            font-size: 14px;
        }
    }

    .tj1:hover {
        img {
            cursor: pointer;
        }

        .tj1A {
            color: #0086d1;
            cursor: pointer;
        }

        .tj1C {

            span {
                background: #181a1b;
                color: #fff;
                padding: 8px 20px;
                font-size: 14px;
                cursor: pointer;
            }
        }
    }
}
</style>